import { classnames } from '@weapp/utils';
import { iconClsPrefix, USESKELETON } from '../../constants/index';
import Loadable, { LoadingType } from '../../react-loadable';
import { IconType, IconProps } from './types';
import IconLoader from './utils/IconLoader';

const IconSkeleton: LoadingType<IconProps> = (props) => {
  if (!USESKELETON) return <span />
  const { className, size, moduleColor } = props;
  const svgWrapper = classnames({
    [`${iconClsPrefix}`]: true,
    [`${iconClsPrefix}-wrapper`]: true,
    [`${iconClsPrefix}-${moduleColor}`]: typeof moduleColor !== 'undefined',
  }, className);
  const svgClassString = classnames({
    [`${iconClsPrefix}-${size}`]: true,
    [`${iconClsPrefix}-svg`]: true,
  });
  return <span className={svgWrapper}><span className={svgClassString} style={{ display: 'inline-block' }}></span></span>
}

// 加载图标 iconMap 文件
IconLoader.loadIconMap();

const Icon = Loadable({
  name: 'Icon',
  loading: IconSkeleton,
  loader: () => import(
    /* webpackChunkName: 'icon' */
    './Icon'),
}) as IconType;

Icon.IconSkeleton = IconSkeleton;

const getSvgIconDom = (iconName: string) => import(
  /* webpackChunkName: 'icon' */
  './utils/getSvgIconDom'
).then((defaultModule) => defaultModule.getSvgIconDom(iconName));

const getSvgIconStr = (iconName: string) => import(
  /* webpackChunkName: 'icon' */
  './utils/getSvgIconDom'
).then((defaultModule) => defaultModule.getSvgIconStr(iconName));


Icon.getSvgIconDom = getSvgIconDom;
Icon.getSvgIconStr = getSvgIconStr;
Icon.getIconMap = IconLoader.loadIconMap;
Icon.IconLoader = IconLoader;

Icon.defaultProps = {
  size: 'xs',
  iconResourceTimeout: 3000
}

export type { IconProps, IconType, IconNames, moduleType as IconModuleColorType } from './types';

// 2024/01/10 所有前端项目源码扫描，未发现使用的地方
// export { ICON_MAP } from './map/sprite'

const ICON_MAP = {};
export { ICON_MAP };

export default Icon;
